import React from 'react';
import MainHeadingContainer from './main-heading.styles';

const MainHeading = ({ title }) => {
    return (
        <MainHeadingContainer>
            <h2>{title}</h2>
            <p>
                Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.
                Mauris blandit aliquet elit, eget tincidunt.
            </p>
        </MainHeadingContainer>
    );
};

export default MainHeading;
